import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Une clases resolviendo conflictos de Tailwind: en `cn('p-2', 'p-4')` gana
 * `p-4`, que es lo que se espera cuando un componente acepta `className` para
 * ajustar el estilo de su padre.
 *
 * Es el mismo helper que asume shadcn/ui, así que un componente copiado de
 * ahí a `src/ui/` funciona sin tocarlo.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
